export default __webpack_public_path__ + "media/images/images/backgrounds/bg-2-6d1d3b241a9e314348918122b9d3f726.jpg";